// extracted by mini-css-extract-plugin
export default {"container":"Summary_container__FhCf1","item":"Summary_item__nyJiQ","summary":"Summary_summary__CDtd0","contrast":"Summary_contrast__yyF37"};